module.exports = __webpack_public_path__ + "static/media/image-client-service-circle.ec7b1db3.svg";